import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {faCog, faCogs} from "@fortawesome/free-solid-svg-icons";
import {debounceTime, filter, switchMap, take} from "rxjs/operators";
import {BehaviorSubject, Subscription} from 'rxjs';
import {
    EnumConnectionType,
    EnumStationFilterType,
    ExperienceLevelType,
    IAccessTable,
    IAppStatic,
    ICRUDCommand,
    Id,
    IStationData,
    IUser
} from "../../../interfaces";
import {StationPropsComponent} from "../station-props/station-props.component";
import {AccessService, AppService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {
    compareIds,
    datetimeToStandardString,
    DEFAULT_STATIONS_POLL,
    DEFAULT_STATIONS_SOCKET_POLL,
    isHostDev,
    isHostDevOrLocal,
    isHostLocal,
    isNullOrUndefOrEmpty,
    LargePageSizeOptions,
    popupWindow
} from '../../../common';
import {timeout} from "../../../decorators/timeout";
import {actionCRUDRecord, actionCustomUrl, actionLoadStationUpdate} from "../../../store/actions/user.actions";
import {DOCUMENT} from "@angular/common";
import {Lib} from "../../../../libs/Lib";
import {StationLiveComponent} from '../station-live/station-live.component';
import {IChartModel} from "../../../components/bar-chart/bar-chart.component";
import {staggerTransitionIn} from "../../../../libs/basicTransition";
import {DialogCodeComponent} from "../../../components/dialog-code/dialog-code.component";
import _ from 'lodash';
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {TranslocoService} from "@ngneat/transloco";
import {actionEnterpriseSendAllCommand} from "../../../store/actions/enterprise.actions";
import {StationAddPlayerComponent} from '../station-add-player/station-add-player.component';

interface IMonitorStation {
    [stationId: string]: {
        showChart: boolean;
        data: Array<IChartModel>
    };
}

@Component({
    selector: 'app-station-list',
    templateUrl: './station-list.component.html',
    styleUrls: ['./station-list.component.scss'],
    animations: [
        staggerTransitionIn
    ]
})
export class StationListComponent extends Compbaser implements OnInit, OnDestroy {

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template

    @Output() toggleMinimize = new EventEmitter<any>();
    formGroup: any;

    @Input()
    set filterByBusinessId(i_value: boolean) {
        this.m_filterByBusinessId = i_value;
    }

    @Input() setLargeView;

    @Input()
    set setMonitorView(v: boolean) {
        this.isMonitorView = v;
        this.stationsUpdate();

    }

    @Input()
    set businessId(i_businessId: Id) {
        this.m_businessId = i_businessId;
        this.stationsUpdate();
    }

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild("noWatchdogModal", {read: TemplateRef}) noWatchdogModal: TemplateRef<any>;
    // @ViewChild("stationLog", {read: TemplateRef}) stationLog: TemplateRef<any>;
    // @ViewChild("networkStatusModal", {read: TemplateRef}) networkStatusModal: TemplateRef<any>;

    experienceLevel: ExperienceLevelType;

    _ready;
    enterpriseMode: boolean;
    pageSizeOptions = LargePageSizeOptions;
    pageSize = 10;
    m_refresh;
    m_refreshSocket;
    m_stationSub$: Subscription;
    m_EnumConnectionType = EnumConnectionType;
    m_EnumConnectionSelected: any = '0';
    faCogs = faCogs;
    faCog = faCog;
    m_filterByBusinessId: boolean;
    dataSource: MatTableDataSource<IStationData>;
    m_businessId: Id;
    displayedColumns: string[]; // 'playing' 'lastUpdate' 'IP' 'totalMemory'
    selection: SelectionModel<number>;
    center = {lat: 38, lng: -103};
    user: IUser;
    accessConfigStations: IAccessTable;
    accessConfigAds: IAccessTable;
    dashboard: boolean;
    debugMode;
    categorySelected;
    categories = [];
    globalFilter = '';
    columnFilter = {
        tree_path: '',
        player_data_id: ''
    };
    activeVersion = '0';
    lastGetTime;
    allowMultiSelect = true;
    stringJSPipeClean = {split: ['_', 1]};
    appSettings: IAppStatic;
    server;
    dataSourceList$: BehaviorSubject<any[]>;
    pageLoading = true;
    radioDisableButtons = false;
    m_isHostLocal = false;
    filterExpanded = true;

    protected readonly isHostLocal = isHostLocal;

    // optionalField = ['playing', 'ip', 'source', 'startTime', 'version', 'watchDogConnection', 'pwa', 'os', 'businessId'];
    // spun = 0;

    /** Monitor **/
    isMonitorView = false;
    monitorPlayers: IMonitorStation = {};
    monitorMaxEntries = 100;
    monitorUrl = 'https://example.com/live'; // test: https://secure.digitalsignage.com/foobar

    m_trackBy = (_index: number, item: IStationData): IStationData => {
        if (item?.stat?.$?.station_business_id && item?.props?.station_business_id) {
            return item;
        }
        item.stat = {
            $: {
                station_business_id: item.props.station_business_id,
                id: item.props.station_id,
                name: '',
                wdConnected: '',
                wdNative: '',
                wdExtension: '',
                libVersion: '',
                connected: '',
                platform: '',
                playerId: '',
                totalMemory: '',
                userHostAddress: '',
                watchDogConnection: '',
                status: '',
                runningTime: '',
                os: '',
                caching: '',
                lastUpdate: '',
                peakMemory: '',
                appVersion: '',
                airVersion: '',
                version: '',
                localAddress: '',
                socket: '',
                connection: '',
                cameraStatus: '',
                lastCameraTest: '',
                businessId: '',
                source: '',
                localIp: '',
                publicIp: '',
                playing: '',
                startTime: '',
                tree_path: '',
                geoLocation: null
            }
        };
        return item;
    };

    constructor(public storeSelector: StoreSelectorsService,
                @Inject(DOCUMENT) private document: Document,
                protected override dialog: MatDialog,
                private appService: AppService,
                public cdr: ChangeDetectorRef,
                private translocoService: TranslocoService,
                private accessService: AccessService,
                private containerService: ContainerService,
                private localStorage: LocalStoreService,
                private route: ActivatedRoute,
                private localStoreService: LocalStoreService) {
        super();
        this.setMe('station-list.component.ts');
        this.debugMode = isHostDevOrLocal();
        const initialSelection = [];
        this.selection = new SelectionModel<number>(this.allowMultiSelect, initialSelection);
        this.appService.pollStations();
        this.pollStationsHard();
        this.m_isHostLocal = isHostLocal();
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                    this.server = `${this.appSettings.globalService}`;
                })
        );

        this.cod(
            this.storeSelector.getLastGetTime()
                .subscribe((v) => {
                    this.lastGetTime = v;
                })
        );
        this.cod(
            this.accessService.getGroupsTable('Stations', 'branch_stations')
                .subscribe((v) => this.accessConfigStations = v)
        );
        this.cod(
            this.accessService.getGroupsTable('Stations', 'station_ads')
                .subscribe((v) => this.accessConfigAds = v)
        );
        this.cod(
            this.route.queryParams.subscribe(params => {
                if (params && params['filter']) {
                    this.applyFilter(params['filter']);
                }
            })
        );
        this.cod(
            this.storeSelector.getUser().pipe(
                take(1),
                switchMap((i_user: IUser) => {
                    this.user = i_user;
                    this.dashboard = i_user.dashboard;
                    this.enterpriseMode = i_user.enterprise;

                    this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                    this.updateDisplayedColumns(); // Alon - is it ok to be without the filter here?
                    return this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig');
                })
            ).subscribe( a => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                this.updateDisplayedColumns(); // Alon - is it ok to be without the filter here?
            })

        );

        this.m_refresh = setInterval(() => {
            this.pollStationsHard();
        }, DEFAULT_STATIONS_POLL);

        this.pingSockets();
        this.m_refreshSocket = setInterval(() => {
            this.pingSockets();
        }, DEFAULT_STATIONS_SOCKET_POLL);
    }

    ngOnInit() {
        this.globalFilter = this.localStorage.getStorageValConfig('stationFilter');
        this.pageSize = parseInt(this.localStorage.getStorageValConfig('pageSize')) || 10;
        this.m_EnumConnectionSelected = this.localStorage.getStorageValConfig('playersFilter') || '0';
        this.activeVersion = this.localStorage.getStorageValConfig('playersConnected') || '0';
        this.monitorUrl = this.localStorage.getStorageValConfig('stationMonitorUrl') || this.monitorUrl;
        if (this.isMonitorView && this.monitorUrl.length > 5) {
            this.changeMonitorUrl({
                target: {
                    value: this.monitorUrl
                }
            });
        }
    }

    updateDisplayedColumns() {
        this.displayedColumns = [];
        this.displayedColumns.push('select', 'status');
        if (this.dashboard || this.experienceLevel > ExperienceLevelType.BEGINNER) {
            this.displayedColumns.push('watchDogConnection', 'version');
        }
        this.displayedColumns.push('name');
        if (this.dashboard || this.experienceLevel > ExperienceLevelType.BEGINNER) {
            this.displayedColumns.push('category', 'startTime', 'appVersion');
        }

        if (this.dashboard) {
            if (!this.displayedColumns.includes("businessId")) {
                this.displayedColumns.push('businessId');
            }
        }
    }

    // listenSelectionChanged() {
    //     this.cod(
    //         this.selection.changed.asObservable().subscribe((a) => {
    //             console.log(this.selection.selected.length);
    //         })
    //     );
    // }

    // checkboxLabel(row?) {
    //     if (!row) {
    //       return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    //     }
    //     return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    // }

    onConnectionType(e) {
        this.selection.clear();
        this.clearFilter();
        this.m_EnumConnectionSelected = e.value + '';
        this.localStorage.setStorageValConfig('playersFilter', this.m_EnumConnectionSelected);
        this.stationsUpdate();
    }

    onPlayerType(e) {
        this.selection.clear();
        this.clearFilter();
        this.activeVersion = e.value + '';
        this.localStorage.setStorageValConfig('playersConnected', this.activeVersion);
        this.stationsUpdate();
    }

    /** Whether number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const pageSize = this.dataSource.paginator.pageSize;
        if (numSelected === pageSize) {
            return true;
        } else {
            if (this.dataSource.filteredData.length > pageSize) {
                return false;
            } else {
                return this.dataSource.filteredData.length === numSelected;
            }
        }
    }

    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            const pageIndex = this.dataSource.paginator.pageIndex;
            const pageSize = this.dataSource.paginator.pageSize;
            let endIndex: number;
            if (this.dataSource.filteredData.length > (pageIndex + 1) * pageSize) {
                endIndex = (pageIndex + 1) * pageSize;
            } else {
                endIndex = this.dataSource.filteredData.length;
            }

            for (let index = (pageIndex * pageSize); index < endIndex; index++) {
                this.selection.select(this.dataSource.filteredData[index].stat.$.station_business_id as any);
            }
        }
    }

    public onOpenDialog() {
        if (this.selection.selected.length === 0) return;
        const dialogRef = this.dialog.open(StationPropsComponent, {
            height: '700px',
            width: '400px',
            data: {selectionModel: this.selection}
        });
        dialogRef.afterClosed().subscribe(() => {
            // this.router.navigateByUrl('/editor/list');
        });
    }

    public onOpenDialogNoWatchdog() {
        this.dialog.open(this.noWatchdogModal, {
            height: '400px',
            width: '500px',
            data: {selectionModel: this.selection}
        });
    }

    stationsUpdate() {
        this.unsubStationListener();
        let filterBusinessId;
        let filterBusinessState;
        if (this.m_filterByBusinessId) {
            filterBusinessId = this.m_businessId;
            filterBusinessState = EnumStationFilterType.BUSINESSES;
        } else {
            filterBusinessId = null;
            filterBusinessState = EnumStationFilterType.NONE;
        }
        let sourceStations: Array<IStationData> = [];

        this.m_stationSub$ = this.storeSelector
            .getStationsComplete(this.m_EnumConnectionSelected, filterBusinessState, filterBusinessId, this.activeVersion)
            .pipe(debounceTime(333))
            .subscribe((v) => {
                sourceStations = v;
                this.updateStations(sourceStations);
                this.buildCategoryDropdown(sourceStations);
            });
    }

    applyFilter(filterValue: string) {
        this.globalFilter = filterValue;
        this.localStorage.setStorageValConfig('stationFilter', filterValue);
        if (this.dataSource) {
            this.dataSource.filter = JSON.stringify(this.columnFilter);
        }
    }

    unsubStationListener() {
        if (this.m_stationSub$)
            this.m_stationSub$.unsubscribe();
    }

    pingSockets() {
        this.appService.stationSocketPing();
    }

    devModeCommandAll(i_command: 'start' | 'stop') {
        const localRemText1 = this.translocoService.translate('general.areYouSure', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: `${localRemText1} ${this.selection.selected.length} want to send to all?`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                let counter = 1;
                this.dataSource.data.forEach((i_stationData) => {
                    counter = counter + 1;
                    setTimeout(() => {
                        this.selection.select(i_stationData.props.station_business_id as any);
                        this.storeSelector.dispatch(actionEnterpriseSendAllCommand({command: i_command}));
                    }, counter * 1000);
                });
            }
        });
    }

    monitorStations() {
        let link;
        const credentials = Lib.EncryptUserPass(this.user.username, this.user.passwordNew);
        if (isHostLocal()) {
            link = `http://localhost:4200/monitor/poll/${credentials}`;
        } else if (isHostDev()) {
            link = `https://dev.signage.me/signstudio/monitor/poll/${credentials}`;
        } else {
            link = `https://galaxy.signage.me/signstudio/monitor/poll/${credentials}`;
        }
        if (!this.isEnterprise()) return;
        popupWindow({url: link, title: 'player monitor', h: '100%', w: '100%'}, 'no', 'yes');
    }

    /** full screen for entire app not just video and support Dialogs **/
    goFullScreen() {
        this.document.getElementsByTagName('body')[0].requestFullscreen().catch();
    }

    openEmbedded() {
        this.dialog.open(DialogCodeComponent, {width: '500px; height: 800px', data: {sceneId: '-1', codeTemplateId: '3'}});
    }

    isEnterprise(): boolean {
        if (this.enterpriseMode) return true;
        this.upgrade();
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
    }

    @timeout(500)
    pollStationsHard() {
        if (this.dashboard) {
            this.appService.syncStationsEnterprise();
        } else {
            /** do not sync until we got at least one data set back from server **/
            if (!this.lastGetTime) return;
            this.appService.syncAccount();
        }
        // this.toastr.info(this.translocoService.translate('toast.refreshPlayersList', {}, this.translocoService.getActiveLang()));
        console.log('refreshing players list');
    }

    private buildCategoryDropdown(dataSource) {
        this.categories = [];
        dataSource.forEach((s) => {
            if (s.props.tree_path) {
                this.categories.push(s.props.tree_path);
            }
        });
        this.categories = this.categories.reduce((x, y) => x.includes(y) ? x : [...x, y], []).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        this.containerService.setCategories(this.categories);
    }

    updateStations(sourceStations) {
        if (this.dataSource) {
            this.dataSource.data = sourceStations;
            if (this.isMonitorView) {
                this.monitorCollectData();
            }
            return;
        }
        this.dataSource = new MatTableDataSource(sourceStations);
        this.initSortPage();

        // this.dataSource.sort = this.sort;
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.filterPredicate = (data: any, filter) => {
        //     const dataStr = JSON.stringify(data).toLowerCase();
        //     return dataStr.indexOf(filter) !== -1;
        // };

        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sortingDataAccessor = (item, property) => {
            return item.stat.$[property];
        };
        if (!isNullOrUndefOrEmpty(this.m_EnumConnectionSelected) && !compareIds(this.m_EnumConnectionSelected, 0)) {
            this.onConnectionType({value: this.m_EnumConnectionSelected});
        }
        if (!isNullOrUndefOrEmpty(this.activeVersion) && !compareIds(this.activeVersion, 0)) {
            this.onPlayerType({value: this.activeVersion});
        }
        if (this.globalFilter) {
            this.applyFilter(this.globalFilter);
        }
        if (this.dataSource) {
            this.dataSourceList$ = this.dataSource.connect();
        }
        // if (this.isMonitorView) {
        //     setTimeout(() => {
        //         this.pageLoading = false;
        //     }, 3000);
        // } else {
        //     this.pageLoading = false;
        // }
        setTimeout(() => {
            this.pageLoading = false;
        }, 3000);
        this.cdr.detectChanges();
    }

    @timeout(333)
    initSortPage() {
        if (!this.dataSource) return;
        if (!this.dataSource.sort) {
            this.dataSource.sort = this.sort;
        }
        if (!this.dataSource.paginator) {
            this.dataSource.paginator = this.paginator;
        }
    }

    filteryByCategory(e) {
        this.columnFilter.tree_path = e.value ? e.value : '';
        this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    private clearFilter() {
        this.categorySelected = '';
        this.columnFilter.tree_path = '';
        this.applyFilter('');
    }

    private customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            let globalMatch = !this.globalFilter;

            if (this.globalFilter) {
                // search all fields
                globalMatch = JSON.stringify(data).toString().toLowerCase().indexOf(this.globalFilter.trim().toLowerCase()) !== -1;
            }
            if (!globalMatch) {
                return false;
            }
            const filterObj = JSON.parse(filter);
            let isFilter = true;
            // tslint:disable-next-line:forin
            for (const col in filterObj) {
                let colData = data[col];
                if (col == 'tree_path') {
                    colData = data.props.tree_path ? data.props.tree_path : "";
                } else if (col == 'player_data_id') {
                    colData = data.props.player_data_id ? data.props.player_data_id : "";
                }
                if (typeof colData === 'undefined' || colData.toString().toLowerCase().indexOf(filterObj[col].trim().toLowerCase()) == -1) {
                    isFilter = false;
                    break;
                }
            }
            return isFilter;
        };
        return myFilterPredicate;
    }

    fieldSettings() {
        const index = this.displayedColumns.indexOf('playing');
        if (index == -1) {
            this.displayedColumns.push('playing');
        } else {
            this.displayedColumns.splice(index, 1);
        }
    }

    changeSendNotification(station: IStationData, sendNotification: boolean) {
        const stationData: any = {
            station_business_id: station.stat.$.station_business_id,
            send_notification: sendNotification
        };
        // const uploadData = _.cloneDeep(station.props);
        // uploadData.send_notification = `${sendNotification}`;
        this.storeSelector.dispatch(actionLoadStationUpdate({value: stationData}));
        this.crudStation('update', station.props.station_id, {send_notification: sendNotification}, station.props.version);
    }

    showMonitorChart(station: IStationData) {
        const monitorPlayer = this.monitorPlayers[station.stat.$.station_business_id];
        if (!monitorPlayer) return;
        monitorPlayer.showChart = !monitorPlayer.showChart;
        this.cdr.detectChanges();
    }

    changeMonitorUrl(e) {
        this.radioDisableButtons = false;
        this.monitorUrl = e.target?.value || '';
        if (this.monitorUrl.length > 5 && this.monitorUrl.indexOf('example.com') === -1 && this.monitorUrl.indexOf('http') > -1) {
            this.radioDisableButtons = true;
        }
        this.m_EnumConnectionSelected = '0';
        this.localStorage.setStorageValConfig('playersFilter', this.m_EnumConnectionSelected);
        this.localStorage.setStorageValConfig('stationMonitorUrl', this.monitorUrl);
        this.stationsUpdate();
    }

    openStatisticModal(station: IStationData) {
        const stationData: IStationData = _.cloneDeep(station);
        if (isNullOrUndefOrEmpty(stationData?.stat?.$?.businessId)) {
            stationData.stat.$.businessId = this.user.businessId;
        }
        this.dialog.open(StationLiveComponent, {
            height: '850px',
            width: '800px',
            data: {stationData}
        });
    }

    showAddPlayerModal() {
        StationAddPlayerComponent.createDialog(this.dialog);
    }

    filterByScene(sceneId) {
        this.columnFilter.player_data_id = sceneId;
        this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    assignToRemoteScenes() {

    }

    private monitorPostRemote(data) {
        if (this.monitorUrl.length < 8) return;
        if (this.monitorUrl.indexOf('example.com') > -1) return;
        if (this.monitorUrl.indexOf('https') === -1 && this.monitorUrl.indexOf('http') === -1) return;
        this.storeSelector.dispatch(actionCustomUrl({payload: {url: this.monitorUrl, data}}));
    }

    private monitorCollectData() {
        if (!this.dataSource?.data || this.dataSource?.data?.length === 0) return;
        const playersChangedStatus = [];
        this.dataSource.data.forEach((i_stationData) => {
            if (!i_stationData.stat) return;
            if (!i_stationData.props.send_notification) return;

            const stationId = i_stationData.stat.$.station_business_id;
            const monitorStation = this.monitorPlayers[stationId];
            const currentConnection = parseInt(i_stationData.stat.$.connection || '0');

            if (!monitorStation) {
                this.monitorPlayers[stationId] = {
                    showChart: false,
                    data: [{
                        time: datetimeToStandardString(new Date()),
                        value: currentConnection
                    }]
                };

            } else {
                const lastEntry = monitorStation.data.length - 1;
                const lastConnection = monitorStation.data[lastEntry].value;
                if (lastConnection !== currentConnection) {
                    console.log(`changed status ${lastConnection} >  ${currentConnection} ${stationId} `);
                    playersChangedStatus.push(i_stationData);

                    monitorStation.data.push({
                        time: datetimeToStandardString(new Date()),
                        value: currentConnection
                    });
                    if (monitorStation.data.length > this.monitorMaxEntries) {
                        monitorStation.data.shift();
                    }
                }
            }
        });
        if (playersChangedStatus.length > 0) {
            this.monitorPostRemote(playersChangedStatus);
        }
        this.cdr.detectChanges();
    }

    private crudStation(command: ICRUDCommand, id, body, stationVersion) {
        let table = '';
        let primary = '';
        if (stationVersion == '1') {
            table = 'branch_stations';
            primary = 'branch_station_id';
        } else if (stationVersion == '2') {
            table = 'stations';
            primary = 'station_id';
            if (body && 'assigned_to' in body) {
                delete body['assigned_to'];
            }
        } else {
            return;
        }

        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStorage.getStorageConfig().studioId,
                command,
                primary,
                table,
                body,
                id
            }
        }));
    }

    override destroy() {
        super.destroy();
        clearInterval(this.m_refresh);
        clearInterval(this.m_refreshSocket);
        this.appService.stopPollStations();
        this.unsubStationListener();
    }

}

